module.exports = __webpack_public_path__ + "static/img/header3.3c222649.jpg";